// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__sQhva","addWidgetButton":"Header_addWidgetButton__2LSzZ","dashboardTabs":"Header_dashboardTabs__BFRNP","active":"Header_active__2plG_"};